module.exports = {
	"data": {
		"postBySlug": {
			"html": "",
			"frontmatter": {
				"title": "dmgt test doc # 2"
			},
			"fields": {
				"slug": "/dmgt-test-doc-2"
			}
		}
	},
	"pathContext": {
		"slug": "/dmgt-test-doc-2"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/dmgt-test-doc-2.json
// module id = 458
// module chunks = 231547272361986